(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["breadcrumbs"] && !Shopify.designMode) return;
  try {
    // Mobile breadcrumb simplification
  function initMobileBreadcrumbs() {
    const breadcrumbItems = document.querySelectorAll('.breadcrumbs__item[data-item-index]');
    
    if (breadcrumbItems.length <= 1) {
      // If only one item or less, show it
      breadcrumbItems.forEach(item => {
        item.classList.add('breadcrumbs__item--mobile-show');
      });
      return;
    }
    
    // Find the second-to-last item (first higher level)
    const secondToLastIndex = breadcrumbItems.length - 2;
    const secondToLastItem = breadcrumbItems[secondToLastIndex];
    
    if (secondToLastItem) {
      secondToLastItem.classList.add('breadcrumbs__item--mobile-show');
    }
  }

  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMobileBreadcrumbs);
  } else {
    initMobileBreadcrumbs();
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["filters"] && !Shopify.designMode) return;
  try {
    class StickyFiltersComponent {
    constructor(element) {
      this.element = element;
      this.lastScrollTop = 0;
      this.relativeTop = 0;
      this.currentBottom = 0;
      this.elementWidth = null;
      /** @type {number} Zichtbare sticky site-header (px). */
      this.headerHeight = 0;
      /** @type {number} Volledige `.facets-controls-wrapper`-rij boven de sidebar (px). */
      this.filtersControlsBarHeight = 0;

      this.handleScroll = this.handleScroll.bind(this);
      this.handleResize = this.handleResize.bind(this);
      this.handleHeightChange = this.handleHeightChange.bind(this);

      // rAF-throttle voor scroll
      this._ticking = false;

      // debounce voor resize
      this._resizeTimer = null;

      // ResizeObserver voor hoogte veranderingen
      this._resizeObserver = null;
      this._heightChangeTimer = null;
      this._lastObservedHeight = 0;

      this.init();
    }

    /**
     * Offset vanaf viewport-top voor sticky sidebar: site-header + controls-balk (niet alleen h4-titel).
     */
    _updateStickyOffsets() {
      const bodyStyles = getComputedStyle(document.body);
      let headerOffset = parseFloat(bodyStyles.getPropertyValue('--header-height')) || 0;
      headerOffset += parseFloat(bodyStyles.getPropertyValue('--announcement-bar-height-above')) || 0;

      const headerComponent = document.querySelector('header-component');
      if (headerComponent instanceof HTMLElement && headerComponent.hasAttribute('sticky')) {
        const headerSection = headerComponent.closest('.header-section') ?? headerComponent;
        const headerBottom = headerSection.getBoundingClientRect().bottom;
        if (headerBottom > 0) {
          headerOffset = Math.max(headerOffset, headerBottom);
        }
      }

      this.headerHeight = headerOffset;

      const collectionWrapper = this.element.closest('.collection-wrapper');
      const controlsWrapper = collectionWrapper?.querySelector('.facets-controls-wrapper');
      if (controlsWrapper instanceof HTMLElement && controlsWrapper.offsetHeight > 0) {
        this.filtersControlsBarHeight = controlsWrapper.offsetHeight;
        return;
      }

      const filtersTitle = collectionWrapper?.querySelector('.facets--filters-title');
      this.filtersControlsBarHeight =
        filtersTitle instanceof HTMLElement && filtersTitle.offsetHeight ? filtersTitle.offsetHeight : 0;
    }

    _getStickyTopInset() {
      return this.headerHeight + this.filtersControlsBarHeight;
    }

    init() {
      if (window.innerWidth < 750) return;

      this._updateStickyOffsets();

      window.addEventListener('scroll', this.handleScroll, { passive: true });
      window.addEventListener('resize', this.handleResize, { passive: true });

      // Luister naar clicks op show-more buttons binnen dit element
      this.element.addEventListener('click', (event) => {
        const showMoreButton = event.target.closest('.show-more__button');
        if (showMoreButton) {
          // Sla de huidige hoogte op VOORDAT de animatie start
          const heightBeforeAnimation = this.element.offsetHeight;
          console.log('[StickyFilters] show-more button clicked', {
            heightBeforeAnimation,
            currentHeight: this.element.offsetHeight
          });
          
          // Wacht tot de animatie klaar is (300ms) plus een kleine buffer
          clearTimeout(this._heightChangeTimer);
          this._heightChangeTimer = setTimeout(() => {
            const heightAfterAnimation = this.element.offsetHeight;
            const heightChanged = heightAfterAnimation !== heightBeforeAnimation;
            
            console.log('[StickyFilters] animatie zou klaar moeten zijn', {
              heightBeforeAnimation,
              heightAfterAnimation,
              heightChanged,
              heightDiff: heightAfterAnimation - heightBeforeAnimation
            });
            
            if (heightChanged) {
              this.handleHeightChange();
            }
          }, 350);
        }
      });

      // Initialiseer ResizeObserver om hoogte veranderingen te detecteren
      if (typeof ResizeObserver !== 'undefined') {
        // Sla de laatste hoogte op om te detecteren of er echt een verandering is
        this._lastObservedHeight = this.element.offsetHeight;
        
        this._resizeObserver = new ResizeObserver((entries) => {
          const currentHeight = this.element.offsetHeight;
          const heightChanged = currentHeight !== this._lastObservedHeight;
          
          console.log('[StickyFilters] ResizeObserver triggered', {
            element: this.element,
            oldHeight: this._lastObservedHeight,
            currentHeight,
            heightChanged,
            entries: entries.map(e => ({ width: e.contentRect.width, height: e.contentRect.height }))
          });
          
          // Update de laatste geobserveerde hoogte
          this._lastObservedHeight = currentHeight;
          
          // Alleen verwerken als de hoogte daadwerkelijk is veranderd
          if (heightChanged) {
            // Wacht iets langer om ervoor te zorgen dat animaties klaar zijn
            // show-more component gebruikt 300ms animatie, dus wacht iets langer
            clearTimeout(this._heightChangeTimer);
            this._heightChangeTimer = setTimeout(() => {
              // Controleer opnieuw of de hoogte nog steeds anders is
              const finalHeight = this.element.offsetHeight;
              if (finalHeight !== this._lastObservedHeight) {
                this._lastObservedHeight = finalHeight;
              }
              this.handleHeightChange();
            }, 350); // Iets langer dan de animatie duur (300ms)
          }
        });
        this._resizeObserver.observe(this.element);
      }

      // Forceer een eerste evaluatie
      // Bij het laden (scrollTop === 0) eerst inline positioning clearen en wachten op rendering
      const scrollTop = this._getScrollTop();
      if (scrollTop === 0 || scrollTop < 10) {
        // Clear alle inline positioning om te voorkomen dat oude absolute positioning blijft staan
        this._clearInlinePositioning();
        this.element.removeAttribute('data-sticky');
        this.element.style.removeProperty('--facets-sticky-top');
        this.element.style.removeProperty('--facets-relative-top');
        
        // Wacht op volledige rendering voordat we de eerste scroll evaluatie doen
        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            // Zet min-height op parent container voordat we scroll evalueren
            this._updateParentMinHeight();
            this.handleScroll();
          });
        });
      } else {
        // Als we niet op de top zijn, direct evalueren
        // Zet min-height op parent container voordat we scroll evalueren
        this._updateParentMinHeight();
        this.handleScroll();
      }
    }

    _getScrollTop() {
      // Cross-browser betrouwbaar scrollY
      const el = document.scrollingElement || document.documentElement;
      return typeof window.scrollY === 'number' ? window.scrollY : el.scrollTop || 0;
    }

    _clearInlinePositioning() {
      this.element.style.position = '';
      this.element.style.top = '';
      this.element.style.left = '';
      this.element.style.right = '';
      this.element.style.width = '';
    }

    _updateParentMinHeight() {
      const parent = this.element.parentElement;
      if (!parent) return;

      // Zoek de .collection-wrapper container (kan direct parent zijn of hoger in de DOM)
      const collectionWrapper = parent.closest('.collection-wrapper');
      if (!collectionWrapper) return;

      // Vind alle filters-gerelateerde elementen binnen de collection-wrapper
      const filtersControlsWrapper = collectionWrapper.querySelector('.facets-controls-wrapper');
      const filtersWrapper = this.element; // .facets-block-wrapper--vertical
      
      // Gebruik getBoundingClientRect om posities te krijgen en bereken relatief aan collection-wrapper
      const collectionRect = collectionWrapper.getBoundingClientRect();
      let totalHeight = 0;
      
      if (filtersControlsWrapper && filtersWrapper) {
        // Beide elementen bestaan: bereken van top eerste tot bottom laatste
        const controlsRect = filtersControlsWrapper.getBoundingClientRect();
        const wrapperRect = filtersWrapper.getBoundingClientRect();
        
        // Bereken posities relatief aan collection-wrapper
        const topElementTop = Math.min(
          controlsRect.top - collectionRect.top,
          wrapperRect.top - collectionRect.top
        );
        const bottomElementBottom = Math.max(
          controlsRect.bottom - collectionRect.top,
          wrapperRect.bottom - collectionRect.top
        );
        
        totalHeight = bottomElementBottom - topElementTop;
      } else if (filtersControlsWrapper) {
        // Alleen controls wrapper bestaat
        const controlsRect = filtersControlsWrapper.getBoundingClientRect();
        totalHeight = controlsRect.bottom - controlsRect.top;
      } else if (filtersWrapper) {
        // Alleen filters wrapper bestaat
        const wrapperRect = filtersWrapper.getBoundingClientRect();
        totalHeight = wrapperRect.bottom - wrapperRect.top;
      }
      
      // Zet de min-height op de collection-wrapper
      if (totalHeight > 0) {
        collectionWrapper.style.minHeight = `${totalHeight}px`;
      }
    }

    handleScroll() {
      if (window.innerWidth < 750) return;

      // rAF-throttle
      if (this._ticking) return;
      this._ticking = true;
      requestAnimationFrame(() => {
        this._updateStickyOffsets();
        const stickyTopInset = this._getStickyTopInset();

        const scrollTop = this._getScrollTop();
        const isScrollingUp = scrollTop < this.lastScrollTop;
        this.lastScrollTop = scrollTop;

        const parent = this.element.parentElement;
        const isSticky = this.element.hasAttribute('data-sticky');

        // Bij scrollTop === 0 (of zeer klein) expliciet zorgen dat element in relative state is
        if (scrollTop === 0 || scrollTop < 10) {
          // Clear alle inline positioning en sticky attributen
          this._clearInlinePositioning();
          this.element.removeAttribute('data-sticky');
          this.element.style.removeProperty('--facets-sticky-top');
          this.element.style.removeProperty('--facets-relative-top');
          
          // Bereken currentBottom voor toekomstige scroll evaluaties
          const rect = this.element.getBoundingClientRect();
          this.currentBottom = scrollTop + rect.top + this.element.offsetHeight;
          
          // Reset relativeTop en elementWidth voor toekomstig gebruik
          if (parent) {
            const parentRect = parent.getBoundingClientRect();
            const elementRect = this.element.getBoundingClientRect();
            this.relativeTop = elementRect.top - parentRect.top;
            this.elementWidth = elementRect.width;
          }
          
          this._ticking = false;
          return;
        }

        if (!isSticky) {
          // Onderkant van het element relatief aan document (scroll + top + hoogte)
          const rect = this.element.getBoundingClientRect();
          const oldCurrentBottom = this.currentBottom;
          this.currentBottom = scrollTop + rect.top + this.element.offsetHeight;
          
          if (oldCurrentBottom !== this.currentBottom) {
            console.log('[StickyFilters] handleScroll - currentBottom updated (not sticky)', {
              scrollTop,
              rectTop: rect.top,
              elementHeight: this.element.offsetHeight,
              oldCurrentBottom,
              newCurrentBottom: this.currentBottom
            });
          }
        }

        // Naar beneden scrollen → sticky onderin viewport (negatieve top)
        if (!isScrollingUp && scrollTop + window.innerHeight >= this.currentBottom) {
          const stickyTop = window.innerHeight - this.element.offsetHeight;
          const stickyOffset = stickyTop > 0 ? -stickyTop : stickyTop;

          console.log('[StickyFilters] handleScroll - naar beneden, sticky onderin viewport', {
            scrollTop,
            windowInnerHeight: window.innerHeight,
            currentBottom: this.currentBottom,
            elementHeight: this.element.offsetHeight,
            stickyTop,
            stickyOffset,
            condition: scrollTop + window.innerHeight >= this.currentBottom
          });

          this._clearInlinePositioning();
          this.element.setAttribute('data-sticky', 'true');
          this.element.style.setProperty('--facets-sticky-top', `${stickyOffset}px`);
          this.element.style.removeProperty('--facets-relative-top');

          if (parent) {
            const parentRect = parent.getBoundingClientRect();
            const elementRect = this.element.getBoundingClientRect();
            this.relativeTop = elementRect.top - parentRect.top;
            this.elementWidth = elementRect.width;
          }

        // Naar boven scrollen → sticky onder header en volledige controls-balk
        } else if (
          isScrollingUp &&
          scrollTop <= (this.currentBottom - this.element.offsetHeight - stickyTopInset)
        ) {
          this._clearInlinePositioning();
          this.element.setAttribute('data-sticky', 'true');
          this.element.style.setProperty('--facets-sticky-top', `${stickyTopInset}px`);
          this.element.style.removeProperty('--facets-relative-top');

          if (parent) {
            const parentRect = parent.getBoundingClientRect();
            const elementRect = this.element.getBoundingClientRect();
            this.relativeTop = elementRect.top - parentRect.top;
            this.elementWidth = elementRect.width;
          }

        // Tussenstuk → absolute positie binnen parent
        } else if (
          (isScrollingUp && isSticky && scrollTop > (this.currentBottom - this.element.offsetHeight)) ||
          (!isScrollingUp && isSticky && scrollTop <= (this.currentBottom - this.element.offsetHeight))
        ) {
          console.log('[StickyFilters] handleScroll - tussenstuk, absolute positie', {
            scrollTop,
            isScrollingUp,
            isSticky,
            currentBottom: this.currentBottom,
            elementHeight: this.element.offsetHeight,
            threshold: this.currentBottom - this.element.offsetHeight,
            condition1: isScrollingUp && isSticky && scrollTop > (this.currentBottom - this.element.offsetHeight),
            condition2: !isScrollingUp && isSticky && scrollTop <= (this.currentBottom - this.element.offsetHeight)
          });

          this.element.removeAttribute('data-sticky');
          this.element.style.removeProperty('--facets-sticky-top');
          this.element.style.removeProperty('--facets-relative-top');

          if (parent) {
            this.element.style.position = 'absolute';
            this.element.style.top = `${this.relativeTop}px`;
            this.element.style.width = this.elementWidth ? `${this.elementWidth}px` : '';
            this.element.style.left = '';
            this.element.style.right = '';
          }
        }
        
        // Log sticky state als het element sticky is
        if (isSticky) {
          const stickyTopValue = this.element.style.getPropertyValue('--facets-sticky-top');
          console.log('[StickyFilters] handleScroll - sticky state check', {
            scrollTop,
            isSticky,
            currentBottom: this.currentBottom,
            elementHeight: this.element.offsetHeight,
            stickyTopValue,
            relativeTop: this.relativeTop
          });
        }

        this._ticking = false;
      });
    }

    handleResize() {
      // Debounce om fladderen bij slepen/resizen te voorkomen
      clearTimeout(this._resizeTimer);
      this._resizeTimer = setTimeout(() => {
        window.removeEventListener('scroll', this.handleScroll);
        window.removeEventListener('resize', this.handleResize);

        this.element.removeAttribute('data-sticky');
        this.element.style.removeProperty('--facets-sticky-top');
        this.element.style.removeProperty('--facets-relative-top');
        this._clearInlinePositioning();

        // Reset state zodat de logica hetzelfde blijft
        this.lastScrollTop = this._getScrollTop();
        this.relativeTop = 0;
        this.currentBottom = 0;
        this.elementWidth = null;

        this.init();
      }, 120);
    }

    handleHeightChange() {
      if (window.innerWidth < 750) return;

      this._updateStickyOffsets();

      const scrollTop = this._getScrollTop();
      const parent = this.element.parentElement;
      const isSticky = this.element.hasAttribute('data-sticky');
      const oldCurrentBottom = this.currentBottom;
      const oldHeight = this.element.offsetHeight;

      // Herbereken currentBottom op basis van nieuwe hoogte
      const rect = this.element.getBoundingClientRect();
      const newHeight = this.element.offsetHeight;
      this.currentBottom = scrollTop + rect.top + newHeight;

      console.log('[StickyFilters] handleHeightChange', {
        scrollTop,
        isSticky,
        oldHeight,
        newHeight,
        heightDiff: newHeight - oldHeight,
        oldCurrentBottom,
        newCurrentBottom: this.currentBottom,
        currentBottomDiff: this.currentBottom - oldCurrentBottom,
        rectTop: rect.top,
        windowInnerHeight: window.innerHeight,
        documentHeight: document.documentElement.scrollHeight
      });

      // Als het element sticky is, pas de sticky top aan zodat het naar boven uitvouwt
      if (isSticky && parent) {
        const parentRect = parent.getBoundingClientRect();
        const elementRect = this.element.getBoundingClientRect();
        const stickyTopValue = this.element.style.getPropertyValue('--facets-sticky-top');
        const stickyTop = stickyTopValue ? parseFloat(stickyTopValue) : 0;
        const heightDiff = newHeight - oldHeight;
        
        console.log('[StickyFilters] handleHeightChange - sticky state, pas aan zodat naar boven uitvouwt', {
          stickyTop,
          stickyTopValue,
          oldHeight,
          newHeight,
          heightDiff,
          parentRectBottom: parentRect.bottom,
          windowInnerHeight: window.innerHeight
        });

        // Als de hoogte is toegenomen, pas de sticky top aan zodat het element naar boven uitvouwt
        if (heightDiff > 0) {
          let newStickyTop = stickyTop;
          
          if (stickyTop < 0) {
            // Negatieve top betekent onderin viewport
            // Pas aan zodat de onderkant op dezelfde plek blijft (naar boven uitvouwen)
            // Als stickyTop = -X, betekent dit dat de bovenkant op window.innerHeight + X is
            // Bij toename van hoogte met heightDiff, moet stickyTop met -heightDiff worden aangepast
            newStickyTop = stickyTop - heightDiff;
            
            // Controleer of we niet boven de parent uitkomen
            const elementBottom = window.innerHeight + newStickyTop + newHeight;
            const parentBottomViewport = parentRect.bottom;
            
            // Als de onderkant door de parent zou gaan, beperk de sticky top
            if (elementBottom > parentBottomViewport) {
              const maxElementBottom = parentBottomViewport;
              const maxStickyTop = window.innerHeight - maxElementBottom;
              newStickyTop = Math.max(newStickyTop, -maxStickyTop);
              
              console.log('[StickyFilters] handleHeightChange - beperk sticky top om binnen parent te blijven', {
                elementBottom,
                parentBottomViewport,
                maxStickyTop,
                adjustedStickyTop: newStickyTop
              });
            }
          } else {
            // Positieve top betekent onder header
            // Pas aan zodat de onderkant op dezelfde plek blijft (naar boven uitvouwen)
            // Bij toename van hoogte met heightDiff, moet stickyTop met -heightDiff worden aangepast
            newStickyTop = stickyTop - heightDiff;
            
            // Controleer of we niet boven de header komen
            const minStickyTop = this._getStickyTopInset();
            if (newStickyTop < minStickyTop) {
              newStickyTop = minStickyTop;
              
              console.log('[StickyFilters] handleHeightChange - beperk sticky top om boven header te blijven', {
                minStickyTop,
                adjustedStickyTop: newStickyTop
              });
            }
            
            // Controleer of we nog steeds binnen de parent passen
            const elementBottom = newStickyTop + newHeight;
            const parentBottomViewport = parentRect.bottom;
            
            if (elementBottom > parentBottomViewport) {
              // Element past niet meer binnen parent, zet terug naar absolute positioning
              console.log('[StickyFilters] handleHeightChange - element past niet meer, terug naar absolute');
              this.element.removeAttribute('data-sticky');
              this.element.style.removeProperty('--facets-sticky-top');
              this.element.style.removeProperty('--facets-relative-top');
              
              // Herbereken relativeTop voor absolute positioning
              const parentRect2 = parent.getBoundingClientRect();
              const elementRect2 = this.element.getBoundingClientRect();
              this.relativeTop = elementRect2.top - parentRect2.top;
              this.elementWidth = elementRect2.width;
              
              if (parent) {
                this.element.style.position = 'absolute';
                this.element.style.top = `${this.relativeTop}px`;
                this.element.style.width = this.elementWidth ? `${this.elementWidth}px` : '';
                this.element.style.left = '';
                this.element.style.right = '';
              }
              
              // Stop hier, we zijn klaar
              this.handleScroll();
              return;
            }
          }
          
          console.log('[StickyFilters] handleHeightChange - pas sticky top aan voor naar boven uitvouwen', {
            oldStickyTop: stickyTop,
            newStickyTop,
            adjustment: newStickyTop - stickyTop
          });
          
          this.element.style.setProperty('--facets-sticky-top', `${newStickyTop}px`);
        }
        
        // Herbereken relativeTop voor het geval dat
        this.relativeTop = elementRect.top - parentRect.top;
        this.elementWidth = elementRect.width;
      }

      // Update min-height op parent container wanneer filters hoogte verandert
      this._updateParentMinHeight();

      // Forceer een nieuwe evaluatie van handleScroll om de positie bij te werken
      this.handleScroll();
    }

    destroy() {
      window.removeEventListener('scroll', this.handleScroll);
      window.removeEventListener('resize', this.handleResize);
      
      // Cleanup ResizeObserver
      if (this._resizeObserver) {
        this._resizeObserver.disconnect();
        this._resizeObserver = null;
      }
      
      // Cleanup height change timer
      if (this._heightChangeTimer) {
        clearTimeout(this._heightChangeTimer);
        this._heightChangeTimer = null;
      }
      
      this.element.removeAttribute('data-sticky');
      this.element.style.removeProperty('--facets-sticky-top');
      this.element.style.removeProperty('--facets-relative-top');
      this._clearInlinePositioning();
    }
  }

  // Initialize voor alle verticale filter wrappers
  const initializeStickyFilters = () => {
    const filterWrappers = document.querySelectorAll('.facets-block-wrapper--vertical:not(#filters-drawer)');
    const instances = new Map();

    filterWrappers.forEach((wrapper) => {
      if (!instances.has(wrapper)) {
        instances.set(wrapper, new StickyFiltersComponent(wrapper));
      }
    });

    return instances;
  };

  let stickyInstances = new Map();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      stickyInstances = initializeStickyFilters();
    });
  } else {
    stickyInstances = initializeStickyFilters();
  }

  // Cleanup bij page unload
  window.addEventListener('beforeunload', () => {
    stickyInstances.forEach((instance) => instance.destroy());
  });

  // Re-initialize na section updates (bij filter changes)
  document.addEventListener('shopify:section:load', () => {
    stickyInstances.forEach((instance) => instance.destroy());
    stickyInstances = initializeStickyFilters();
  });

  // Mobile sticky facets toggle component
  class MobileStickyFacetsToggle {
    constructor(element) {
      this.element = element;
      this.resultsList = document.querySelector('results-list');
      
      this.facetsToggleTop = 0;
      this.resultsListBottom = 0;
      // Spacer is een sibling van het element, niet een child
      // Zoek de spacer door naar het parent element te gaan en dan te zoeken
      const parent = this.element.parentElement;
      this.spacer = parent ? parent.querySelector('.facets-toggle-spacer') : null;
      this.elementHeight = 0;
      
      this.handleScroll = this.handleScroll.bind(this);
      this.handleResize = this.handleResize.bind(this);
      
      // debounce voor resize
      this._resizeTimer = null;
      
      this.init();
    }

    init() {
      if (window.innerWidth >= 750) return;

      window.addEventListener('scroll', this.handleScroll, { passive: true });
      window.addEventListener('resize', this.handleResize, { passive: true });

      // Forceer een eerste evaluatie
      this.updatePositions();
      this.handleScroll();
    }

    updatePositions() {
      const rect = this.element.getBoundingClientRect();
      const scrollTop = window.scrollY || document.documentElement.scrollTop;
      this.facetsToggleTop = scrollTop + rect.top;
      this.elementHeight = rect.height;

      if (this.resultsList) {
        const resultsRect = this.resultsList.getBoundingClientRect();
        this.resultsListBottom = scrollTop + resultsRect.top + resultsRect.height;
      }
    }

    updateSpacer(shouldBeSticky) {
      if (this.spacer && this.elementHeight > 0) {
        // Update spacer height VOORDAT we de sticky class toevoegen/verwijderen
        // om verspringing te voorkomen
        this.spacer.style.height = shouldBeSticky ? `${this.elementHeight}px` : '0px';
      }
    }

    handleScroll() {
      if (window.innerWidth >= 750) {
        this.element.classList.remove('facets-toggle--sticky');
        return;
      }

      const scrollTop = window.scrollY || document.documentElement.scrollTop;
      
      // Update positions als nodig
      if (!this.facetsToggleTop || !this.resultsListBottom) {
        this.updatePositions();
      }

      const isPastFacetsToggle = scrollTop >= this.facetsToggleTop;
      const isPastResultsList = this.resultsList && scrollTop >= this.resultsListBottom;

      const shouldBeSticky = isPastFacetsToggle && !isPastResultsList;
      const isCurrentlySticky = this.element.classList.contains('facets-toggle--sticky');

      // Update spacer height altijd op basis van shouldBeSticky, niet op basis van huidige state
      // Dit voorkomt verspringing omdat de spacer altijd de juiste hoogte heeft
      this.updateSpacer(shouldBeSticky);

      if (shouldBeSticky !== isCurrentlySticky) {
        if (shouldBeSticky) {
          // Update element height before making sticky
          if (!isCurrentlySticky) {
            this.updatePositions();
            // Update spacer met nieuwe hoogte
            this.updateSpacer(true);
          }
          this.element.classList.add('facets-toggle--sticky');
        } else {
          this.element.classList.remove('facets-toggle--sticky');
        }
      }
    }

    handleResize() {
      // Debounce om fladderen bij slepen/resizen te voorkomen
      clearTimeout(this._resizeTimer);
      this._resizeTimer = setTimeout(() => {
        if (window.innerWidth >= 750) {
          this.element.classList.remove('facets-toggle--sticky');
          return;
        }

        this.updatePositions();
        this.updateSpacer();
        this.handleScroll();
      }, 120);
    }

    destroy() {
      window.removeEventListener('scroll', this.handleScroll);
      window.removeEventListener('resize', this.handleResize);
      this.element.classList.remove('facets-toggle--sticky');
      if (this.spacer) {
        this.spacer.style.height = '0px';
      }
    }
  }

  // Initialize mobile sticky facets toggle
  const initializeMobileStickyFacetsToggle = () => {
    const facetsToggle = document.querySelector('.facets-toggle');
    if (!facetsToggle) return null;

    return new MobileStickyFacetsToggle(facetsToggle);
  };

  let mobileStickyInstance = null;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      mobileStickyInstance = initializeMobileStickyFacetsToggle();
    });
  } else {
    mobileStickyInstance = initializeMobileStickyFacetsToggle();
  }

  // Cleanup bij page unload
  window.addEventListener('beforeunload', () => {
    if (mobileStickyInstance) {
      mobileStickyInstance.destroy();
    }
  });

  // Re-initialize na section updates (bij filter changes)
  document.addEventListener('shopify:section:load', () => {
    if (mobileStickyInstance) {
      mobileStickyInstance.destroy();
    }
    mobileStickyInstance = initializeMobileStickyFacetsToggle();
  });

  // Helper functie om sticky filters opnieuw te evalueren
  const reEvaluateStickyFilters = () => {
    // Wacht tot de browser de scroll positie heeft hersteld
    // Gebruik requestAnimationFrame om te wachten tot de volgende frame
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        // Bij resize van mobiel naar desktop: re-initialize desktop instances
        if (window.innerWidth >= 750 && stickyInstances.size === 0) {
          stickyInstances = initializeStickyFilters();
        }

        // Bij resize van desktop naar mobiel: destroy desktop instances
        if (window.innerWidth < 750 && stickyInstances.size > 0) {
          stickyInstances.forEach((instance) => instance.destroy());
          stickyInstances.clear();
        }

        // Reset en herbereken sticky filters voor desktop
        stickyInstances.forEach((instance, element) => {
          if (instance && instance.element) {
            // Reset state
            instance.lastScrollTop = instance._getScrollTop();
            instance.currentBottom = 0;
            instance.relativeTop = 0;
            instance.elementWidth = null;

            // Forceer herberekening
            instance.handleScroll();
          }
        });

        // Reset en herbereken mobile sticky toggle
        if (window.innerWidth < 750) {
          // Re-initialize mobile instance als deze niet bestaat
          if (!mobileStickyInstance) {
            mobileStickyInstance = initializeMobileStickyFacetsToggle();
          }

          if (mobileStickyInstance) {
            mobileStickyInstance.updatePositions();
            mobileStickyInstance.handleScroll();
          }
        } else {
          // Destroy mobile instance als we naar desktop gaan
          if (mobileStickyInstance) {
            mobileStickyInstance.destroy();
            mobileStickyInstance = null;
          }
        }
      });
    });
  };

  // Re-initialize na popstate (browser back/forward)
  // Registreer direct, niet binnen een if statement
  (function() {
    let lastWindowWidth = window.innerWidth;
    
    window.addEventListener('popstate', () => {
      lastWindowWidth = window.innerWidth;
      reEvaluateStickyFilters();
    });

    // Backup: re-evaluate na pageshow (voor volledige page loads vanuit cache)
    window.addEventListener('pageshow', (event) => {
      // event.persisted is true wanneer de pagina vanuit de bfcache komt
      if (event.persisted) {
        lastWindowWidth = window.innerWidth;
        reEvaluateStickyFilters();
      }
    });

    // Re-evaluate bij resize (voor breedte wijzigingen tussen mobiel/desktop)
    let resizeTimeout;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(() => {
        const currentWidth = window.innerWidth;
        const wasMobile = lastWindowWidth < 750;
        const isMobile = currentWidth < 750;
        
        // Alleen re-evaluate als we switchen tussen mobiel en desktop
        if (wasMobile !== isMobile) {
          lastWindowWidth = currentWidth;
          reEvaluateStickyFilters();
        }
      }, 200);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["popup-link"] && !Shopify.designMode) return;
  try {
    // Detect scroll in popup-link drawers and add background to sticky title
  document.addEventListener('DOMContentLoaded', () => {
    const handleDrawerScroll = (inner) => {
      const firstChild = inner.firstElementChild;
      if (!firstChild) return;
      
      // Check if first child is a heading
      const isHeading = firstChild.matches('h1, h2, h3, h4, h5, h6, .h1, .h2, .h3, .h4, .h5, .h6') ||
                        firstChild.querySelector('h1, h2, h3, h4, h5, h6, .h1, .h2, .h3, .h4, .h5, .h6');
      
      if (isHeading) {
        const updateScrollState = () => {
          if (inner.scrollTop > 0) {
            inner.classList.add('is-scrolled');
          } else {
            inner.classList.remove('is-scrolled');
          }
        };
        
        inner.addEventListener('scroll', updateScrollState, { passive: true });
        updateScrollState(); // Check initial state
      }
    };
    
    // Handle existing drawers
    document.querySelectorAll('.popup-link__content--drawer .popup-link__inner').forEach(handleDrawerScroll);
    
    // Handle dynamically opened drawers
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === 1) { // Element node
            const inner = node.querySelector?.('.popup-link__content--drawer .popup-link__inner') ||
                         (node.matches?.('.popup-link__content--drawer .popup-link__inner') ? node : null);
            if (inner) {
              handleDrawerScroll(inner);
            }
          }
        });
      });
    });
    
    observer.observe(document.body, { childList: true, subtree: true });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["product-review-stars"] && !Shopify.designMode) return;
  try {
    // Inline star rendering utilities
  function snapRating(rating) {
    const wholePart = Math.floor(rating);
    const decimalPart = rating - wholePart;
    
    let snappedDecimal;
    
    if (decimalPart <= 0.125) {
      snappedDecimal = 0;
    } else if (decimalPart <= 0.375) {
      snappedDecimal = 0.25;
    } else if (decimalPart <= 0.5) {
      snappedDecimal = 0.5;
    } else if (decimalPart <= 0.75) {
      snappedDecimal = 0.5;
    } else if (decimalPart <= 0.875) {
      snappedDecimal = 0.75;
    } else {
      snappedDecimal = 0.75;
    }
    
    return wholePart + snappedDecimal;
  }

  function createStarSVG(isFull, fillPercentage, starColor, emptyColor) {
    const starId = `star-${Math.random().toString(36).substr(2, 9)}`;
    
    return `
      <svg width="20" height="20" viewBox="0 0 24 24" class="star-svg">
        <defs>
          <linearGradient id="${starId}" x1="0%" y1="0%" x2="100%" y2="0%">
            <stop offset="0%" style="stop-color:${starColor};stop-opacity:1" />
            <stop offset="${fillPercentage}%" style="stop-color:${starColor};stop-opacity:1" />
            <stop offset="${fillPercentage}%" style="stop-color:${emptyColor};stop-opacity:1" />
            <stop offset="100%" style="stop-color:${emptyColor};stop-opacity:1" />
          </linearGradient>
        </defs>
        <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" fill="url(#${starId})" />
      </svg>
    `;
  }

  function renderStarsHTML(average, starColor, emptyColor) {
    const snappedRating = snapRating(average);
    let starsHTML = '';
    
    for (let i = 1; i <= 5; i++) {
      if (snappedRating >= i) {
        starsHTML += createStarSVG(true, 100, starColor, emptyColor);
      } else if (snappedRating > i - 1) {
        const fillPercentage = Math.round(((snappedRating - (i - 1)) * 100));
        starsHTML += createStarSVG(false, fillPercentage, starColor, emptyColor);
      } else {
        starsHTML += createStarSVG(false, 0, starColor, emptyColor);
      }
    }
    
    return starsHTML;
  }

  function ldJsonTypeNames(node) {
    const t = node && node['@type'];
    if (t == null) return [];
    return Array.isArray(t) ? t : [t];
  }

  function ldJsonIsProductGroup(node) {
    return ldJsonTypeNames(node).includes('ProductGroup');
  }

  function ldJsonIsProduct(node) {
    return ldJsonTypeNames(node).includes('Product');
  }

  function ldJsonHasUsableAggregateRating(node) {
    const ar = node && node.aggregateRating;
    if (!ar || typeof ar !== 'object') return false;
    const rv = ar.ratingValue;
    if (rv == null || rv === '') return false;
    const n = Number(rv);
    return Number.isFinite(n) && n > 0;
  }

  function ldJsonFindProductRoot(node) {
    if (!node || typeof node !== 'object') return null;
    if (Array.isArray(node['@graph'])) {
      const graph = node['@graph'];
      const group = graph.find(ldJsonIsProductGroup);
      if (group) return group;
      const product = graph.find(ldJsonIsProduct);
      return product || null;
    }
    if (ldJsonIsProductGroup(node)) return node;
    if (ldJsonIsProduct(node)) return node;
    return null;
  }

  function ldJsonFindMergeTarget(parsed) {
    if (Array.isArray(parsed)) {
      for (let i = 0; i < parsed.length; i++) {
        const found = ldJsonFindProductRoot(parsed[i]);
        if (found) return found;
      }
      return null;
    }
    return ldJsonFindProductRoot(parsed);
  }

  function mergeYotpoAggregateRatingIntoLdJson(average, count) {
    if (typeof window === 'undefined') return;
    if (window.__hdsYotpoAggregateRatingMerged) return;

    const ratingValue = Math.round(Number(average) * 100) / 100;
    if (!Number.isFinite(ratingValue) || ratingValue <= 0) return;

    const reviewCount = Math.floor(Number(count));
    const rc = Number.isFinite(reviewCount) && reviewCount > 0 ? reviewCount : null;

    const scripts = document.querySelectorAll('script[type="application/ld+json"]');
    for (let s = 0; s < scripts.length; s++) {
      const script = scripts[s];
      let parsed;
      try {
        parsed = JSON.parse(script.textContent.trim());
      } catch {
        continue;
      }

      const target = ldJsonFindMergeTarget(parsed);
      if (!target || ldJsonHasUsableAggregateRating(target)) continue;

      const aggregateRating = {
        '@type': 'AggregateRating',
        ratingValue,
        bestRating: 5,
        worstRating: 1
      };
      if (rc != null) aggregateRating.reviewCount = rc;

      target.aggregateRating = aggregateRating;
      script.textContent = JSON.stringify(parsed);
      window.__hdsYotpoAggregateRatingMerged = true;
      return;
    }
  }

  class ProductReviewStars {
    constructor(element) {
      this.element = element;
      this._clickBound = false;
    }

    async init() {
      try {
        // Laad provider
        await this.loadProvider();
        
        // Resolve product ID
        const productId = await this.resolveProductId();
        
        if (!productId) {
          this.handleFailure('Product ID kon niet worden bepaald');
          this.setupClickHandler();
          return;
        }
        
        // Laad bottomline data
        await this.loadBottomlineData(productId);
        
        this.setupClickHandler();
      } catch (error) {
        this.handleFailure('ProductReviewStars init mislukt', error);
        this.setupClickHandler();
      }
    }

    async reloadFromDom() {
      window.__hdsYotpoAggregateRatingMerged = false;
      try {
        await this.loadProvider();
        const productId = await this.resolveProductId();
        if (!productId) {
          this.handleFailure('Product ID kon niet worden bepaald');
          return;
        }
        await this.loadBottomlineData(productId);
      } catch (error) {
        this.handleFailure('ProductReviewStars reloadFromDom mislukt', error);
      }
    }
    
          async loadProvider() {
            const providerName = this.element.dataset.providerName;
            
            // Wacht tot de provider registry geladen is
            let attempts = 0;
            while (!window.getProvider && attempts < 50) {
              await new Promise(resolve => setTimeout(resolve, 100));
              attempts++;
            }
            
            if (!window.getProvider) {
              throw new Error('Provider registry niet geladen');
            }
            
            const baseProvider = await window.getProvider(providerName);
            
            // Maak een kopie van het provider object om extensible te maken
            this.provider = { ...baseProvider };
            
            if (providerName === 'yotpo') {
              const appKey = this.element.dataset.yotpoAppKey;
              if (!appKey) {
                throw new Error('Yotpo App Key is vereist');
              }
              this.provider.appKey = appKey;
            }
          }
    
    async resolveProductId() {
      const mode = this.element.dataset.productIdMode || 'auto';
      const customId = this.element.dataset.productIdCustom;
      
      if (mode === 'custom') {
        return customId || null;
      }
      
      const productData = this.getProductData();
      
      if (mode === 'shopify_id') {
        return productData?.id?.toString() || null;
      }
      
      if (mode === 'handle') {
        return productData?.handle || null;
      }
      
      // Auto mode: probeer in volgorde
      const candidates = [
        customId,
        productData?.id?.toString(),
        productData?.handle
      ].filter(Boolean);
      
      return candidates[0] || null;
    }
    
    getProductData() {
      const picker = document.querySelector('variant-picker[data-product-id]');
      if (picker?.dataset?.productId) {
        return { id: String(picker.dataset.productId) };
      }

      const sticky = document.querySelector('sticky-add-to-cart[data-product-id]');
      if (sticky?.dataset?.productId) {
        return { id: String(sticky.dataset.productId) };
      }

      const scripts = document.querySelectorAll('script[type="application/ld+json"]');
      for (let i = 0; i < scripts.length; i++) {
        try {
          const parsed = JSON.parse(scripts[i].textContent.trim());
          const target = ldJsonFindMergeTarget(parsed);
          if (!target) continue;

          if (ldJsonIsProductGroup(target) && target.productGroupID != null && target.productGroupID !== '') {
            const handle =
              typeof target.url === 'string' ? target.url.match(/\/products\/([^/?]+)/)?.[1] : null;
            return { id: String(target.productGroupID), ...(handle ? { handle } : {}) };
          }

          if (ldJsonIsProduct(target) && target.sku) {
            const handle =
              typeof target.url === 'string' ? target.url.match(/\/products\/([^/?]+)/)?.[1] : null;
            return { id: String(target.sku), ...(handle ? { handle } : {}) };
          }

          if (ldJsonIsProduct(target) && typeof target.url === 'string') {
            const handle = target.url.match(/\/products\/([^/?]+)/)?.[1];
            if (handle) return { handle };
          }
        } catch {
          continue;
        }
      }

      const productIdMeta = document.querySelector('meta[name="product-id"]');
      const productHandleMeta = document.querySelector('meta[name="product-handle"]');
      if (productIdMeta || productHandleMeta) {
        return {
          id: productIdMeta?.content,
          handle: productHandleMeta?.content
        };
      }

      const urlMatch = window.location.pathname.match(/\/products\/([^/?]+)/);
      if (urlMatch) {
        return { handle: urlMatch[1] };
      }

      if (window.Shopify?.product) {
        return window.Shopify.product;
      }

      return null;
    }
    
    async loadBottomlineData(productId) {
      try {
        // Probeer eerst bottomline API (snelste route)
        const bottomlineOptions = {
          productId: productId,
          appKey: this.provider.appKey,
          debug: this.isDebugMode()
        };
        
        const bottomlineSummary = await this.provider.fetchSummary(bottomlineOptions);
        
        if (bottomlineSummary && bottomlineSummary.average > 0) {
          this.renderStars(bottomlineSummary);
          return;
        }

        const reviewsOptions = {
          productId: productId,
          perPage: 1, // Alleen eerste review nodig voor summary
          page: 1,
          sort: 'date',
          direction: 'desc',
          appKey: this.provider.appKey,
          debug: this.isDebugMode()
        };
        
        const reviewsData = await this.provider.fetchReviews(reviewsOptions);
        
        if (reviewsData?.summary?.average > 0) {
          this.renderStars(reviewsData.summary);
        } else {
          this.renderStars({ average: 0, count: 0 });
        }
        
      } catch (error) {
        this.handleFailure('Fout bij laden van review data', error);
      }
    }
    
    renderStars(data) {
      const container = this.element.querySelector('.review-stars-container');
      if (!container) return;
      
      const average = data.average || 0;
      const count = data.count || 0;
      
      // Haal kleuren uit data-attributen
      const starColor = this.element.dataset.starColor || '#b8915c';
      const emptyColor = this.element.dataset.starEmptyColor || '#d1d1d1';
      
      let contentHTML = '';
      
      // Sterren
      contentHTML += '<div class="review-stars-stars">';
      contentHTML += renderStarsHTML(average, starColor, emptyColor);
      contentHTML += '</div>';
      
      // Gemiddelde score alleen tonen als er reviews zijn
      if (this.element.dataset.showAverageScore === 'true' && count > 0) {
        const formattedScore = average.toFixed(1).replace('.', ',');
        contentHTML += `<span class="review-stars-text">${formattedScore}/5</span>`;
      }
      
      // Aantal reviews
      if (this.element.dataset.showReviewCount === 'true' && count > 0) {
        const countText = count === 1 ? 'review' : 'reviews';
        contentHTML += `<span class="review-stars-count">(${count} ${countText})</span>`;
      }
      
      container.innerHTML = `<div class="review-stars-content">${contentHTML}</div>`;
      container.setAttribute('aria-busy', 'false');

      if (average > 0) {
        mergeYotpoAggregateRatingIntoLdJson(average, count);
      }
    }
    
    setupClickHandler() {
      if (this._clickBound) return;
      this._clickBound = true;

      this.element.addEventListener('click', () => {
        this.scrollToTarget();
      });

      this.element.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          this.scrollToTarget();
        }
      });
    }
    
    scrollToTarget() {
      const target = this.element.dataset.scrollTarget;
      
      if (!target) {
        return;
      }
      
      const targetElement = document.querySelector(target);
      
      if (targetElement) {
        targetElement.scrollIntoView({ 
          behavior: 'smooth',
          block: 'start'
        });
      }
    }
    
    handleFailure(message, error) {
      if (error !== undefined) {
        console.error('[ProductReviewStars]', message, error);
      } else {
        console.error('[ProductReviewStars]', message);
      }
      this.renderStars({ average: 0, count: 0 });
    }
    
    isDebugMode() {
      return this.element.dataset.debugMode === 'true';
    }
  }

  function bootProductReviewStars() {
    document.querySelectorAll('.product-review-stars').forEach((element) => {
      let inst = element.__hdsProductReviewStars;
      if (!inst) {
        inst = new ProductReviewStars(element);
        element.__hdsProductReviewStars = inst;
      }
      void inst.init();
    });
  }

  document.addEventListener('DOMContentLoaded', bootProductReviewStars);

  document.addEventListener('variant:update', (e) => {
    if (!e.detail?.data?.newProduct) return;
    document.querySelectorAll('.product-review-stars').forEach((element) => {
      let inst = element.__hdsProductReviewStars;
      if (!inst) {
        inst = new ProductReviewStars(element);
        element.__hdsProductReviewStars = inst;
      }
      void inst.reloadFromDom();
    });
  });
  } catch(e) { console.error(e); }
})();

})();
